package com.nonopn.skydome.common.app.navigation

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import com.nonopn.skydome.common.app.home.AppModel
import com.nonopn.skydome.common.app.home.LocalApp
import com.nonopn.skydome.common.app.pages.documents.DocumentsScreen
import com.nonopn.skywatcher.common.app.res.Res
import com.nonopn.skywatcher.common.app.res.title_documents
import com.nonopn.skywatcher.design.appbar.AppBarState
import eu.codlab.navigation.NavigateTo
import eu.codlab.navigation.NavigateToStack
import eu.codlab.navigation.NavigateWithNavOptions
import eu.codlab.navigation.Route
import eu.codlab.navigation.RouteParameterTo
import eu.codlab.navigation.RouterNoParameters
import kotlinx.serialization.Serializable

@Serializable
object RouteDocuments : RouteParameterTo

object RouterDocuments : RouterNoParameters<RouteDocuments>(RouteDocuments::class) {
    override fun routeFrom(parameters: RouteDocuments) = "/documents"

    @Composable
    override fun Show(parameters: RouteDocuments) {
        RouteDocumentsImpl().scene()
    }

    override fun navigateTo() = NavigateTo(
        route = RouteDocuments,
        stack = NavigateToStack(
            popBackStack = true,
            options = NavigateWithNavOptions(launchSingleTop = true)
        )
    )

    override fun isCurrentRoute(routeParameterTo: RouteParameterTo?) =
        null != routeParameterTo && routeParameterTo is RouteDocuments

    override fun isMatching(route: String) = route == "/documents"

    override fun navigateFrom(path: String) = RouteDocuments
}

class RouteDocumentsImpl : Route<RouteDocuments>(
    route = "/documents",
    params = RouteDocuments,
) {
    @Composable
    override fun scene() {
        val appModel: AppModel = LocalApp.current
        val state by appModel.states.collectAsState()

        LaunchedEffect(Unit) {
            appModel.setAppBarState(
                AppBarState.Localized(
                    title = Res.string.title_documents,
                    emptyList()
                )
            )
        }

        if (null == state.apiProvider?.apiNormal) return

        DocumentsScreen()
    }
}
